import { Carousel as NukaCarousel } from 'nuka-carousel';
import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, FontWeights, minWidth, Text } from '@calm-web/design-system';

import ChevronRightIcon from 'icons/chevron-left-centered.svg';

export const Photo = styled.div`
	grid-area: photo;
`;
export const Attribution = styled(Text).attrs({ el: 'p', noMargin: true })``;
export const MemberSince = styled(Text).attrs({
	size: FontSizes.sm,
	el: 'p',
	noMargin: true,
})`
	grid-area: description;
`;

export const Section = styled.section`
	margin: 40px 14px;
	${minWidth('tablet')} {
		margin: 75px;
	}
`;

export const GridWrapper = styled.div`
	margin: 30px auto;
	max-width: 1168px;
	display: grid;
	grid-template-columns: 1fr;

	${minWidth('tablet')} {
		gap: 48px;
		margin: 48px auto;
		grid-template-columns: 1fr 1fr;
	}
`;

export const StatText = styled(Text).attrs({
	size: FontSizes.base,
	noMargin: true,
	weight: FontWeights.Medium,
	el: 'li',
})<{ $isActive: boolean }>`
	color: ${palette('text')};
	padding: 20px 0;
	${minWidth('tablet')} {
		${fontSize(FontSizes.lg)}
		padding: 10px 0;
		cursor: pointer;
		color: ${p => (p.$isActive ? palette('text')(p) : palette('gray4')(p))};
	}
`;

export const AttributionWrapper = styled.div`
	grid-area: attribution;
	margin-left: 15px;
	${minWidth('tablet')} {
		margin-left: 30px;
	}
`;
export const Quote = styled(Text).attrs({ el: 'p', noMargin: true })`
	grid-area: quote;
	align-self: start;
`;
export const TestimonialWrapper = styled.div`
	background-color: ${palette('gray0')};
	border-radius: 10px;
	display: grid;
	row-gap: 27px;
	grid-template-columns: 48px 1fr;
	grid-template-rows: 1fr min-content;
	grid-template-areas:
		'quote quote'
		'photo attribution';
	padding: 20px;
	${minWidth('tablet')} {
		padding: 50px;
	}
	min-width: 100%;
	max-width: 560px;
	/* height: 320px; */
`;
export const QuotesWrapper = styled.div`
	max-width: 560px;
	overflow-x: hidden;
	margin: 30px 0;
	${minWidth('tablet')} {
		margin: 0;
	}
`;
export const StatsWrapper = styled.ul`
	display: flex;
	flex-direction: column;
	justify-content: start;
	align-items: stretch;
	padding: 0;

	& li {
		border-bottom: 1px solid ${palette('gray2')};
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		flex-grow: 1;
		&:first-child {
			border-top: 1px solid ${palette('gray2')};
		}
	}

	& li > :last-child {
		margin-left: auto;
		min-width: 24px;
	}
`;
export const ChevronRight = styled(ChevronRightIcon)`
	display: none;
	${minWidth('tablet')} {
		display: block;
		height: 24px;
		width: 24px;
		transform: rotate(180deg);
		align-self: center;

		& path {
			fill: ${p => (p.$isActive ? palette('text') : palette('gray2'))};
		}
	}
`;
export const StatSourceDetail = styled(Text).attrs({
	color: 'gray4',
	size: FontSizes.sm,
	el: 'p',
})``;
export const StatHighlight = styled(Text).attrs({
	color: 'blue3',
	size: FontSizes.base,
	weight: FontWeights.Demi,
})`
	padding: 0 20px;
	${minWidth('tablet')} {
		padding-right: 24px;
		${fontSize(FontSizes.xl)}
	}
`;

export const Carousel = styled(NukaCarousel)`
	overflow: visible;
`;
